import React, {  useEffect, useRef, useState } from 'react'
import "./ManageRole.css";

import Chip from "@material-ui/core/Chip";
import _without from "lodash/without";

import {  Autocomplete, Box, Button, Tab, TextField } from '@mui/material';
import GenericMultiSelect from '../../components/Input/GenericMultiSelect';
import { setManageRoleState } from '../../stateManagement/actions/manageRoleAction';

import { useSelector } from 'react-redux';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {  metaDataBatchPayload, popupType } from '../../types/types';
import { GenericPopUp } from '../../components/popup/genericPopUp';
import { convertToPortalLayout, getMetaDataConfig, postConfiguration, saveRoleInDB, updateConfiguration, validateMetaDataResponse } from '../../services/uiConfigService';
import { configurationAttributeType, configurationAttrValueType } from '../../types';
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import store from '../../stateManagement/store';
import * as Sentry from "@sentry/react";
import { appFeatureRegistry, defaultAppLayoutConfig, defaultRoleMapping, featureType, manageRoleRegistry, portalFeatureRegistry, roleAccessMapping, roleAccessOptionsTypes, roleType } from './ManageRoleRegistry';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import { sfaConfigOptions, uiConfigOptions } from '../../components/uiConfigSidebar/UiConfigSidebar';
import { getLob } from '../../services/authenticationService';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import { META_DATA_BATCH_API } from '../../services/networkService';


function MangeRoleHeading(props:{heading:string, showEditIcon?:boolean}) {
    const {heading,showEditIcon}=props
  return (
    <div className='manage_role_header'>
        <div>{heading}</div>
    </div>
  )
}


function ManageRole() {
    const roleAccessOptions:roleAccessOptionsTypes[]=['app','portal']
    const editRoleDefaultHeading='edit an existing role';
    const [customRoles,setCustomRoles]=useState<{[key: string]: string[]}>({});
    const [editRoleHeading, setEditRoleHeading] = useState(editRoleDefaultHeading)
    const state = useSelector((state)=>state) as any;
    const reduxManageRoleState = state.manageRoleState
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [editOpenConfirmationModal, setEditOpenConfirmationModal] = useState(false);
    const [createOpenConfirmationModal, setCreateOpenConfirmationModal] = useState(false);
    const [roleMapping,setRoleMapping]=useState<{[key: string]: string[]}>(defaultRoleMapping)
    const [accessRoleMapping, setAccessRoleMapping] = useState<roleAccessMapping>({})
    const [featureOptions, setFeatureOptions] = useState<string[]>([])//"app" is default
    const [roleOptions,setRoleOptions] = useState<string[]>(Object.keys(manageRoleRegistry[reduxManageRoleState.roleAccessType as roleAccessOptionsTypes]));
    const [selectedRole,setSelectedRole] = useState<string>("");
    const [uiConfigIds,setUiConfigIds] = useState<string[]>([]);
    const [selectedUiConfigs,setSelectedUiConfigs] = useState<string[]>([]);
    

    useEffect(() => {
      // let tempFeatureOptions:string[]=[]
      const roles=Object.keys(accessRoleMapping);
      let tempRoles:any={};
      switch(reduxManageRoleState.roleAccessType){
        case 'app':{
          // appFeatureRegistry.forEach(element => {
          //   tempFeatureOptions.push(element.displayName);
          // });

          // filter out respective roles list
          roles.forEach((role)=>{
            if(accessRoleMapping[role]?.accessType=='app' ){
              tempRoles = {...tempRoles,[role]:customRoles[role]}
            }
          })
          break;
        }
        case 'portal':{
          // portalFeatureRegistry.forEach(element => {
          //   tempFeatureOptions.push(element.displayName);
          // });
          // filter out respective roles list
          roles.forEach((role)=>{
            if(accessRoleMapping[role]?.accessType=='portal' ){
              tempRoles = {...tempRoles,[role]:customRoles[role]}
            }
          })
          break;
        }
      }
      setRoleMapping({...defaultRoleMapping,...tempRoles})
      // setFeatureOptions(tempFeatureOptions);
      if(!reduxManageRoleState.editMode) clearState();
    }, [reduxManageRoleState.roleAccessType,customRoles])
    
  useEffect(() => {
    const accessType: roleAccessOptionsTypes = reduxManageRoleState.roleAccessType
      const curRoleFeatureOptions = manageRoleRegistry[accessType]?.[selectedRole as roleType];
      let tempFeatureOptions:string[]= curRoleFeatureOptions?.filter((featureObj: featureType) => !featureObj.default).map((featureObj: featureType) => {
        return featureObj.displayName;
      }) || [];
      if(!reduxManageRoleState.editMode) setSelectedUiConfigs([]);
      setFeatureOptions(tempFeatureOptions);
  },[selectedRole]) 

  const handleFeatureSelection = (selectedOptions: string[]) => {
    setManageRoleState({selectedFeatures: selectedOptions});
  };

  const handleUiConfigSelection = (selectedOptions: string[]) => {
    setSelectedUiConfigs(selectedOptions);
  }
  const handleRoleSelection = (selectedOptions: string[]) => {

    const addedOptionCount=selectedOptions.length-reduxManageRoleState.selectedRoleDirectoryOptions.length;

    //case 1 when options are added
    if(addedOptionCount>0){ 
      const newSelectedOptions:string[]=(addedOptionCount==1)?[selectedOptions[selectedOptions.length-1]]:selectedOptions; //either one option will be selected at once or all options
      let newFeatures:string[]=reduxManageRoleState.selectedFeatures;
      newSelectedOptions.forEach((newSelectedOption) => {
        newFeatures=[...newFeatures,...(roleMapping[newSelectedOption].filter((val:string)=>!newFeatures.includes(val)))] //takes only those mapings which are not already selected
      });
      setManageRoleState({selectedFeatures: newFeatures});
    }
    //case 2 when options are removed
    else{
      let allMappedFeatures:string[]=[];
      selectedOptions.forEach((option) => {
        allMappedFeatures=[...allMappedFeatures,...(roleMapping[option].filter((val:string)=>!allMappedFeatures.includes(val))) ]
      });
      const removedOption:string=reduxManageRoleState.selectedRoleDirectoryOptions.find((option:string)=>!selectedOptions.includes(option))
      const removedOptions:string[]=addedOptionCount==-1?[removedOption]:reduxManageRoleState.selectedRoleDirectoryOptions;
      let removeFeature:string[]=[];
      removedOptions.forEach((option)=>
        removeFeature=[...removeFeature,...roleMapping[option].filter((val:string)=>!allMappedFeatures.includes(val))] //returns features not in all mapped but present in removed role
      )
      const newSelectedfeatures=reduxManageRoleState.selectedFeatures.filter((option:string)=>!removeFeature.includes(option))
      setManageRoleState({selectedFeatures: newSelectedfeatures});
    }

    setManageRoleState({selectedRoleDirectoryOptions: selectedOptions});
  };


  function handleRoleAccessSelection(e: React.ChangeEvent<{}>, value: string|null){
    if(value!=null){
      setManageRoleState({roleAccessType: value});
      const availableRoles = Object.keys(manageRoleRegistry[value as "app" | "portal"])
      setRoleOptions(availableRoles);
    }
  }

  const handleDelete = (e: React.MouseEvent, value: string) => {
    e.preventDefault();
    const newChips=reduxManageRoleState.selectedFeatures.filter((chip: string)=>{
      return chip!==value;
    })

    if(newChips.length==0){
      setManageRoleState({selectedRoleDirectoryOptions:[]});
    }
    setManageRoleState({selectedFeatures:newChips});
  };

  const handleUiConfigDelete = (e: React.MouseEvent, value: string) => {
    e.preventDefault();
    const newChips= selectedUiConfigs.filter((chip: string)=>{
      return chip!==value;
    })

    setSelectedUiConfigs(newChips);
  };

  const handleValueChange=(e: React.ChangeEvent<HTMLInputElement>)=>{
    const key:string=e.target.name;
    setManageRoleState({[key]: e.target.value});
  }
  const handleRoleChange = (event: React.SyntheticEvent,value: string | null) => {
    if(value){
      setSelectedRole(value);
      if(value!=="other"){
        setManageRoleState({newRoleName: value});
      }
    }
  }

  const handleTabChange = (newValue: string) => {//event: React.SyntheticEvent, 
    setManageRoleState({tabValue:newValue})
    clearState();
  };


  const clearState=()=>{
    setSelectedRole("");
    setManageRoleState({newRoleName:''})
    setManageRoleState({selectedFeatures:[]})
    setManageRoleState({selectedRoleDirectoryOptions:[]})
    setManageRoleState({editMode:false})
    // setManageRoleState({roleAccessType:'both'})
    setEditRoleHeading(editRoleDefaultHeading);
    setSelectedUiConfigs([]);
  }
 const convertValuesToConfig =(roleFeatures:string[]):configurationAttributeType<featureType[]>[]=> {
    let featureConfigValue:featureType[]=[];
    let tempFeatureObject:featureType | undefined;
    const result:configurationAttributeType<featureType[]>[]=[];
    const accessType = reduxManageRoleState.roleAccessType as roleAccessOptionsTypes;
    const accessTypeRegistry = manageRoleRegistry[accessType]?.[selectedRole as roleType] ?? [];
    roleFeatures.forEach((featureName)=>{
      
      tempFeatureObject=accessTypeRegistry.find((element:featureType)=>{return element.displayName === featureName})
      if(tempFeatureObject!=undefined){
        const featureObjectCopy = {...tempFeatureObject};
        delete featureObjectCopy.default;
        featureConfigValue.push(featureObjectCopy);
      }
      const defaultFeatureObjects = accessTypeRegistry.filter((featureObj: featureType) => featureObj.default).map((featureObj: featureType) => {
        const featureObjectCopy = {...featureObj};
        delete featureObjectCopy.default;
        return featureObjectCopy;
      })
      featureConfigValue.push(...defaultFeatureObjects);
    })
    let tempAttribute: configurationAttributeType<featureType[]> = {
      "name": 'featureConfig',
      "type": "list",
      "value": featureConfigValue,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "role Config",
      "possibleVals": [],
  };


  result.push(tempAttribute);
  return result;
  }
  async function getFinalRequestBody(){
    const convertedVals:configurationAttributeType<featureType[]>[]=convertValuesToConfig(reduxManageRoleState.selectedFeatures);
    const configName=reduxManageRoleState.newRoleName+'_'+reduxManageRoleState.roleAccessType+"_feature_configuration"
    const updatedRole = reduxManageRoleState.newRoleName;
    const roleAccessType = reduxManageRoleState.roleAccessType;
    const lob = getLob();
    const featureConfigPayload = {
      domainName: "clientconfig",
      domainType: configName,
      domainValues: convertedVals,
      lob
    }
    const finalMetaDataPayload: metaDataBatchPayload = { features: [featureConfigPayload]};
    let clientConfig = await getMetaDataConfig("clientconfig");
    const layoutName = `${reduxManageRoleState.newRoleName}_portal_layout_configuration`;
    const roleLayoutConfig = clientConfig.find((config: { domainType: string }) => config.domainType === layoutName);
    if (reduxManageRoleState.editMode) {
     if(roleAccessType==="portal"){
        const portalLayoutConfig = convertToPortalLayout(convertedVals[0].value,selectedUiConfigs,store?.getState().portalConfigState?.roleOrderLayout,roleLayoutConfig);
        const portalLayoutPayload = {
          domainName: "clientconfig",
          domainType: `${updatedRole}_portal_layout_configuration`,
          domainValues: portalLayoutConfig,
          lob
        }
        finalMetaDataPayload.features.push(portalLayoutPayload);
     }
    
        
    } else{
      if(roleAccessType==="app"){
        const appLayoutPayload =  {
          domainName: "clientconfig",
          domainType: `${updatedRole}_app_layout_configuration`,
          domainValues: deepClone(defaultAppLayoutConfig),
          lob
        }
        finalMetaDataPayload.features.push(appLayoutPayload);
      }else{ //for portal
        const portalLayoutConfig = convertToPortalLayout(convertedVals[0].value,selectedUiConfigs,store?.getState().portalConfigState?.roleOrderLayout,roleLayoutConfig);
        const portalLayoutPayload = {
          domainName: "clientconfig",
          domainType: `${updatedRole}_portal_layout_configuration`,
          domainValues: portalLayoutConfig,
          lob
        }
        finalMetaDataPayload.features.push(portalLayoutPayload);
      }

    }
    return finalMetaDataPayload;
  }
  const saveConfiguration=async ()=>{

    try {
    if(reduxManageRoleState.newRoleName.length==0){
      openPopup('Error',"Please enter Role Name",);
    }else if(reduxManageRoleState.selectedFeatures.length==0){
      openPopup('Error',"Please select some features");
    }else if(Object.keys(customRoles).includes(reduxManageRoleState.newRoleName) && !reduxManageRoleState.editMode){
      openPopup('Error',"Role Already exists");
    }else{
      const finalRolePayload = await getFinalRequestBody();
      validateWithOtp(async (verifiedOTPUser?: manageUpdateAccessObj,verifyResponse?: any)=>{
        try{
          const updatedRole = reduxManageRoleState.newRoleName;
          const roleAccessType = reduxManageRoleState.roleAccessType;
          if (verifyResponse.status === 200 || verifyResponse.status === 201) {
          const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
            if(validationObj.success){
              if (!reduxManageRoleState.editMode) {
                  await saveRoleInDB(updatedRole,roleAccessType);
              }
              setCustomRoles({
              ...customRoles,
              [reduxManageRoleState.newRoleName]:reduxManageRoleState.selectedFeatures
              })
              setAccessRoleMapping({
                ...accessRoleMapping,
                [reduxManageRoleState.newRoleName]: { ...accessRoleMapping[reduxManageRoleState.newRoleName], uiConfigFeatures: selectedUiConfigs}
              })
              const curRole = JSON.parse(localStorage.authContext).user.roles[0].name;
              if(updatedRole === curRole && roleAccessType==="portal"){
                openPopup("Success","Configuration Updated click on continue button to view reflected changes or refresh",() => {
                  window.location.reload();
                });
              }else{
                openPopup('Success',"Configuration Updated");
              }
        
              //clear all states
              clearState();
              setManageRoleState({editMode:false})
            }else{
              throw new Error();
            }
          }else{
            throw new Error();
          }
        }
        catch(err){
          openPopup("Error","Something went wrong");
        }
        
      },undefined,"all",META_DATA_BATCH_API,finalRolePayload,"PUT")
    }
  }catch(err){
    console.log(err);
  }
}

  async function getRoleConfiguration(): Promise<any> {
    try{
        let clientConfig = await getMetaDataConfig("clientconfig");
        let tempCustomRoles={};
        let tempRoleAccessMapping: roleAccessMapping={};

        clientConfig.forEach( (element:{domainType:string,domainValues:any[]}) => {
          const configName = element.domainType;
          const isAppRoleConfig = configName.endsWith('app_feature_configuration');
          const isPortalRoleConfig = configName.endsWith('portal_feature_configuration');
          
          if(isAppRoleConfig || isPortalRoleConfig){
            const tempRoleAccessType = isAppRoleConfig? "app" : "portal";
            const roleTypeIndex = configName.lastIndexOf(tempRoleAccessType);
            let roleName= configName.substring(0,roleTypeIndex-1);
            const roleType = Object.keys(manageRoleRegistry[tempRoleAccessType]).includes(roleName)? roleName : "other";
            const curRoleFeatureOptions = manageRoleRegistry[tempRoleAccessType]?.[roleType as roleType];
            const featureNames:string[] = element.domainValues[0]?.value.filter((configFeature: featureType) => { 
              const registryObj = curRoleFeatureOptions?.find((featureObj) => featureObj.name===configFeature.name)
              if(registryObj){
                return !registryObj.default //exclude default options for roleType to hide them from user
              }else{
                return false; // do not include any feature which is not present in registry
              }
            }).map((item: { displayName: string }) => item.displayName);
            tempCustomRoles={...tempCustomRoles,[roleName]:featureNames}
            tempRoleAccessMapping={...tempRoleAccessMapping,[roleName]: { ...tempRoleAccessMapping[roleName], accessType: tempRoleAccessType }}
          }else{
            const isPortalLayoutConfig = configName.endsWith('portal_layout_configuration');
            if(isPortalLayoutConfig){
              const roleTypeIndex = configName.lastIndexOf("portal");
              const roleName = configName.substring(0,roleTypeIndex-1);
              const uiConfigLayout = element.domainValues.find((layoutObj) => {
                return layoutObj.name === "uiConfigLayout"
              });
              if(uiConfigLayout){
                tempRoleAccessMapping={...tempRoleAccessMapping,[roleName]: {...tempRoleAccessMapping[roleName], uiConfigFeatures: uiConfigLayout?.value ?? []} }
              }
            }
          }
        });
        if(reduxManageRoleState.editMode && reduxManageRoleState.newRoleName && reduxManageRoleState.roleAccessType==="portal"){
          setSelectedUiConfigs(tempRoleAccessMapping?.[reduxManageRoleState.newRoleName]?.uiConfigFeatures)
        }
        setCustomRoles(tempCustomRoles);
        setAccessRoleMapping(tempRoleAccessMapping);
    }catch(err){
        // Sentry.captureException(err);
        console.log("err===",err)
    }
}

  useEffect(() => {
      getRoleConfiguration();
      const uiConfigIds = uiConfigOptions.map((option) => option.id);
      const sfaUiConfigIds = sfaConfigOptions.map((option) => option.id);
      setUiConfigIds([...uiConfigIds,...sfaUiConfigIds]);
  }, [])

  
  const handleEditRole=(roleName:string)=>{
    setManageRoleState({editMode:true})
    setEditRoleHeading(roleName)
    const roleOption = Object.keys(manageRoleRegistry[accessRoleMapping[roleName].accessType as roleAccessOptionsTypes ]).includes(roleName) ? roleName : "other";
    setSelectedRole(roleOption);
    const customRoleFeatures:string[]=customRoles[roleName];
    setManageRoleState({selectedFeatures:customRoleFeatures})
    setManageRoleState({newRoleName:roleName})
    setManageRoleState({roleAccessType: accessRoleMapping[roleName].accessType})
    if(accessRoleMapping[roleName].accessType==="portal") setSelectedUiConfigs(accessRoleMapping[roleName]?.uiConfigFeatures);
  }

  const checkPopUpCondition=()=>{
    if(reduxManageRoleState.newRoleName.length!=0 || reduxManageRoleState.selectedFeatures.length!=0){
      reduxManageRoleState.tabValue=='1'?setEditOpenConfirmationModal(true):setCreateOpenConfirmationModal(true)
    }else{
      reduxManageRoleState.tabValue=='1'?handleTabChange('2'):handleTabChange('1')
    }
  }

    
  return (
    <div className='manage_role'>
        <div className='manage_role_container manage_role_containers'>
            <div className='role_heading'>Role Configuration</div>
            <Box sx={{ width: "100%"}} className="manage_role_tabs">
        <TabContext value={reduxManageRoleState.tabValue}>
          <Box sx={{ borderColor: "divider" }}>
            <TabList
              onChange={checkPopUpCondition}
              aria-label="lab API tabs example"
              variant="fullWidth"
            >
              <Tab label="CREATE ROLE" value="1"  className='tab_list_manage_role'/>
              <Tab label="EDIT ROLE" value="2" className='tab_list_manage_role'/>
            </TabList>
          </Box>

          <TabPanel value="1">
            
          <div className='create_role_accordian'>
            <MangeRoleHeading heading='CREATE A NEW ROLE'/>

           
            
            <Autocomplete
              className={`${reduxManageRoleState.editMode?"hide_autocomplete":''}`}
              disablePortal
              value={reduxManageRoleState.roleAccessType}
              id="combo-box-demo"
              options={roleAccessOptions}
              onChange={handleRoleAccessSelection}
              sx={{ marginTop:2 }}
              renderInput={(params) => <TextField {...params} label="Role Access Type" />}
            />
            <Autocomplete
              className="role_name_field"
              disablePortal
              value={selectedRole}
              id="newRoleName"
              options={roleOptions}
              onChange={handleRoleChange}
              sx={{ marginTop:1 }}
              renderInput={(params) => <TextField {...params} label="Select Role" />}
            />
            {selectedRole==="other" && <TextField  className='role_name_field' name='newRoleName' size='small' label={'Role Name'} variant="outlined" value={reduxManageRoleState.newRoleName} onChange={handleValueChange}/>}
            {/* <GenericMultiSelect options={Object.keys(roleMapping)} label={''} selectedOptions={reduxManageRoleState.selectedRoleDirectoryOptions} handleMultiSelectState={handleRoleSelection} isRequired={false} /> */}
          </div>
            
          </TabPanel>

          <TabPanel value="2">
             
          <div className='edit_role_container'>
                <MangeRoleHeading heading={editRoleHeading} showEditIcon={true}/>
                {reduxManageRoleState.editMode?
                <>
                {/* <GenericMultiSelect className='edit_role_multiselect' options={Object.keys(roleMapping)} label={''} selectedOptions={reduxManageRoleState.selectedRoleDirectoryOptions} handleMultiSelectState={handleRoleSelection} isRequired={false} /> */}
                <div className='edit_another_role_div'><p onClick={()=>setEditOpenConfirmationModal(true)} className="edit_role_text">Edit Another Role</p></div>
                </>
                :<div className='edit_role_options'>
                    {Object.keys(customRoles).map((role,index)=>{
                        return  <div className='role_option_tile' onClick={()=>handleEditRole(role)}>
                                    {role}
                                </div>
                    })}
                </div>}
          </div>
            
          </TabPanel>
        </TabContext>
      </Box>
            
            
        </div>
        <div className={`manage_role_feature_container manage_role_containers`}>
          <div className={`${(reduxManageRoleState.editMode==false && reduxManageRoleState.tabValue==2)?"hide_feature":''}`}>
          <div className='feature_heading'>
          <div className='role_heading'>Features</div>

              <div className='manage_role_save_button'>
                <Button  variant="contained"  onClick={saveConfiguration}>Save</Button>
              </div>

          </div>
        

        <div className='manage_role_multiselect'>
            <div style={{width:'100%'}}>
                <GenericMultiSelect options={featureOptions} label={''} limitTags={100} selectedOptions={reduxManageRoleState.selectedFeatures} handleMultiSelectState={handleFeatureSelection} isRequired={false} />
            </div>
        </div>
        <div >
        <h4>Added Features</h4>
        {reduxManageRoleState.selectedFeatures?.map((value: string) => (
          <Chip className='feature_chips'
            key={value}
            label={value}
            onDelete={(e) => handleDelete(e, value)}
          />
        ))}
       {reduxManageRoleState.selectedFeatures?.find((featureName: string) => {
        return featureName === "UI Config";
       }) && <>
           <div className='manage_role_multiselect'>
              <div style={{width:'100%'}}>
                <GenericMultiSelect options={uiConfigIds} label={'Select UI config features'} limitTags={100} selectedOptions={selectedUiConfigs} handleMultiSelectState={handleUiConfigSelection} isRequired={false} />
              </div>
          </div>
          
          <h4>Added UI Configs</h4>
          {selectedUiConfigs && selectedUiConfigs.map((value: string) => (
          <Chip className='feature_chips'
            key={value}
            label={value}
            onDelete={(e) => handleUiConfigDelete(e, value)}
          />
        ))}
        </>}
      </div>
      </div>
        </div>
        <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={setOpenGenericModal} />
        <ConfirmationPopUp message="Unsaved changes will be lost!"
                               openConfirmModal={createOpenConfirmationModal}
                               setOpenConfirmModal={setCreateOpenConfirmationModal}
                               successMethod={() => handleTabChange('1')}/>
        <ConfirmationPopUp message="Unsaved changes will be lost!"
                               openConfirmModal={editOpenConfirmationModal}
                               setOpenConfirmModal={setEditOpenConfirmationModal}
                               successMethod={() => handleTabChange('2')}/>
    </div>
  )
}

export default ManageRole
